import React from "react";
import UserContext from "./UserContext";
import { login as apiLogin } from "./Api";
import PropTypes from "prop-types";
import { apiCall as aCall, apiCallGetArrayBuffer as aCallGetArrayBuffer } from "./Api";
import { build } from "../version.json";

import { loadImagerParameter, createImageFromTempArray } from "../tools/jsprocedure";
import jimp from 'jimp';

import { trackPromise } from 'react-promise-tracker';

import { withTranslation } from 'react-i18next';

require('dotenv').config();    // use the env. file at project root

const AUTH_KEY = "viewer";
const STATE_KEY = "viewer";

const STATE_KEYS_TO_STORE = [
  "selectedcamera",
  "selectedColorPatter",
];

const sequencesUrl = process.env.REACT_APP_API_SEQUENCES;  // patient/session/sequence
const patientsUrl = process.env.REACT_APP_API_PATIENTS;
const ownerContactUrl = process.REACT_APP_API_OWNERCONTACT;
const sessionByPatientsUrl = process.REACT_APP_API_SESSIONBYPATIENT;
const sequencesBySession = process.env.REACT_APP_API_SEQUENCESBYSESSION;
const imagesThumbnailBySequences = process.env.REACT_APP_API_IMAGESTHUMBNAILBYSEQUENCES;
const imagesFullSizePng = process.env.REACT_APP_API_IMAGESFULLSIZEPNG;
const imagesFullSize = process.env.REACT_APP_API_IMAGESFULLLSIZE;
const imagesThumbnailInSession = process.env.REACT_APP_API_IMAGESTHUMBNAILINSESSION;
const corlormapUrl = process.env.REACT_APP_API_COLORMAP;
const refreshTokenUrl = process.env.REACT_APP_API_REFRESHTOKEN;

const logoutUrl = process.env.REACT_APP_API_LOGOUT;


class UserStore extends React.Component {

    
    constructor(props) {
        super(props);
        this.state = {
            accesstoken: "",
            accesstoken_expiry: {},
            refreshtoken: "",
            refreshtoken_expiry: {},

            alertSeverity: "",
            alertMessage: "",

           // patients: [],
           // selectedPatient: {},

            parameters: [],
            selectedParameter: {},

            localStorageChecked: false,
            languageSelected: "fi",
            searchOpen: false,

            searchOptionsOpen: true,

            availableOpc: true,

            animals: [],
            animalGralList: [],
            animalList: [],
            animalNameList: [],
            selectedAnimal: {},
            selectedAnimalName: "",

            animalInfoOpen: [],
            sessionInfoOpen: [],
            SequencenInfoOpen: [],

            owners: [],
            ownersNameList: [],
            selectedOwner: {},
            selectedOwnerName: "",

            sessions: [],
            selectedSession: {},

            sequences: [],
            selectedSequence: {},

            imagesThumbnailBySequences: [],
            selectedImagesThumbnail: "",
            selectedImagesThumbnailData: [],
            isExtendedImg: false,
            openList: true,

            colorMapList: [],
            colorMap: [],
            colorMapSelected: "RainHi",    // TODO: move to settings
            colorMapSelectedCode64: "",

            imageSize: [{ "x": 0, "y": 0 }],
            pixelTemp: 0.0,
            thumbnailsData: [],

            isFirstSearching: true,

            isCelcius: true,
        };

       /*
       this.handleAnimalSelect = this.handleAnimalSelect.bind(this);
        this.handleAnimalSelectByName = this.handleAnimalSelectByName.bind(this);
        this.handleOwnerSelectByName = this.handleOwnerSelectByName.bind(this);
        
        */
 

    }

      async componentDidMount() {    
        let data = {};
        try {
            console.log("data", data);
            console.log(localStorage.getItem(AUTH_KEY));

            if (this.isJSON(localStorage.getItem(AUTH_KEY))) {
                data = JSON.parse(localStorage.getItem(AUTH_KEY));
                const { accesstoken, user, accesstoken_expiry} = data;
                const tempType = localStorage.getItem("TemperatureType");
                console.log("storage params: ", accesstoken, user, accesstoken_expiry, tempType);
                await this.setState({ accesstoken, user, accesstoken_expiry, tempType});
                await this.resetStateFromLocalStorage();

                console.log("params after resetFrom LS: ", accesstoken, user, accesstoken_expiry);

                accesstoken && this.checkIfExpired(accesstoken_expiry);

                console.log(accesstoken);

                if (accesstoken) {
                    this.fetchPatientsHistory(this.state.user);
                    this.fetchColorMaps();
                    //this.fetchParameters();
                }

            } else
                console.log("No local info yet");
           //accesstoken && this.watchNewUiVersion();
            
            //console.log(accesstoken);
            if (accesstoken)                      
            {
                this.fetchAnimalsHistory(this.state.user);
                this.fetchColorMaps();
                //this.fetchParameters();
            } 

            

        } catch (e) {
            console.log("Failed to parse tokens. ", e.message);
        }
      }

    isJSON = (str) => {
        try {
            return (JSON.parse(str) && !!str);
        } catch (e) {
            console.log("Localstorage:", str);
            return false;
        }
    }

      resetStateFromLocalStorage = () => {
        const json = localStorage.getItem(STATE_KEY);
        try {
          const object = JSON.parse(json);
            //console.log(object);
          /*const { startDate, endDate } = object;
          if (startDate) {
            object.startDate = new Date(startDate);
          }
          if (endDate) {
            object.endDate = new Date(endDate);
          } */
          object.localStorageChecked = true;
          this.setState({ ...object });
        } catch (e) {
          localStorage.removeItem(STATE_KEY);
          console.log("Failed to restore state");
          this.setState({localStorageChecked: true});
        }
      }

      setStateToLocalStorage() {
        const stateToSave = STATE_KEYS_TO_STORE.reduce((acc, key) => {
          if (typeof this.state[key] !== "undefined") {
            acc[key] = this.state[key];
          }
          return acc;
        }, {});
        localStorage.setItem(STATE_KEY, JSON.stringify(stateToSave));
      }



        // VET: Patients = Animal
        /*
         * Fetch ---all--- /patients/sessions/sequences ---
         */
        fetchAnimalsHistory = async (user) => {
            let animalGralList = await this.handleAnimalGralList();
            if (animalGralList.length > 0) {
                let animalsNameList = await this.handleAnimalsNameList(animalGralList);
                let ownersNameList = await this.handleOwnersNameList(animalGralList);
                this.setState({ animals: animalGralList, animalGralList: animalGralList, 
                    animalList: animalGralList, animalNameList: animalsNameList, 
                    ownersNameList: ownersNameList, animalInfoOpen:[], isFirstSearching: false });
            } else
                this.setState({ isFirstSearching: false });
        }


        handleAnimalGralList = async () => {
            let aTemp = [];
            if (this.state.animals.length >= 1) {                    // return active list 
                aTemp = this.state.animalGralList;
            } else {                                               // search all animal
                const result = await this.apiCall("get", sequencesUrl, {});
                if (result) 
                    aTemp = result.data;
                else 
                    this.setState({
                        alertSeverity: "error",
                        alertMessage: "Network error accessing data"
                    });
            }

            return aTemp;

        }

        handleAnimalsNameList = async (animalGralList) => {
            let animalNameList = [];
            animalNameList.push(this.props.t("(No animal selected)"));
            animalGralList.forEach((animal, i) => {
                animalNameList[i + 1] = animal.name;
            });
            return animalNameList;
        }

        handleOwnersNameList = async (animalGralList) => {
            let ownersNameList = [];
            ownersNameList.push(this.props.t("(No owner selected)"));
            animalGralList.forEach((animal) => {
                animal.owners.map((owner) => (
                    ownersNameList.indexOf(owner.name) === -1 ? ownersNameList[ownersNameList.length] = owner.name : null));
            });

            return ownersNameList;
        }


        /*
         * Fetch ---selected---
         */
        fetchAnimalHistory = async (id) => {
            let aTemp = [];
            const result = await this.apiCall("get", sequencesUrl + id, {}, );     // TODO: ADD user.id to API
            aTemp = result.data;
            atemp.forEach((animal, i) => atemp[i].name = i + "-" + animal.name );

            this.setState({ animals: aTemp, });
        }

        /*
         * Fetch ---all--- patient for logged in user
         */
        fetchAnimals = async (user) => {
            const result = await this.apiCall("get", patientsUrl, {},); 
            let animalNameList = [];
            let aTemp = result.data;
            //console.log(result.data);
            //aTemp.forEach((animal, i) => { atemp[i].name = i + "-" + animal.name; animalNameList[i] =  animal.name });
            this.setState({ animalList: result.data, animalNameList: animalNameList });                
        }

        fetchOwnersByAnimal = async (animal) => {
            const result = await this.apiCall("get", ownerContactUrl, {},);  
                let arrTemp = [];
                result.data.forEach((owner, i) =>  arrTemp[i] = owner.name );
                this.setState({ owners: arrTemp });
        }

        fetchSessionByAnimal= async (animal) => {
            const result = await this.apiCall("get", sessionByPatientsUrl + animal.id, {}, ); 
            if (result) {
                let arrTemp = [];
                result.data.forEach((session, i) =>  arrTemp[i] = session.starttime );
                this.setState({ sessions: arrTemp });
            } else {
                this.setState({
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
            }
        }

        fetchSequencesBySessionByAnimal = async (session) => {
            const result = await this.apiCall("get", sequencesBySession + session.id + "/deep", {}); 
            if (result) {
                let arrTemp = [];
                //console.log("SeqBySession", result);
                result.data.forEach((sequence, i) => arrTemp[i] = sequence.starttime);
                this.setState({ sequences: arrTemp });
            } else {
                this.setState({
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    selectedSequence: {},
                    searchOpen: false,
                    searchOptionsOpen: true,
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
            }
        }

        fetchImagesThumbnailBySequences = async (sequence) => {

            const result = await this.apiCall("get", imagesThumbnailBySequences + sequence.id, {},);
            if (result) {
                let arrTemp = result.data.map((image) => image);

                if (arrTemp.length > 0) {
                    //let urlImageFullsizeDefault = process.env.REACT_APP_API_BASE + imagesFullSizePng + arrTemp[0].id;
                    let urlImageFullsizeDefault = arrTemp[0].id;
                    const resultImage = await this.fetchImagesFullsize(arrTemp[0].id);
                    //console.log(arrTemp);
                    let thumbnailsData = await this.calculateThumbnailsTemperatureValue(arrTemp);
                    //console.log(thumbnailsData);
                    this.setState({
                        imagesThumbnailBySequences: arrTemp,
                        thumbnailsData: thumbnailsData,
                        selectedImagesThumbnail: urlImageFullsizeDefault,
                        selectedImagesThumbnailData: resultImage,
                        selectedSequence: sequence,
                        searchOpen: true,
                        searchOptionsOpen: true,
                        isExtendedImg: arrTemp[0].width > 1024 * 1.1 ? true : false,
                        openList: arrTemp[0].width > 1024 * 1.1 ? false : true,
                    });
                    console.log(arrTemp[0].width);

                } else {
                    this.setState({
                        imagesThumbnailBySequences: [],
                        thumbnailsData: [],
                        selectedImagesThumbnail: "",
                        selectedImagesThumbnailData: [],
                        selectedSequence: {},
                        searchOpen: false,
                        searchOptionsOpen: true,
                    });
                }
                // console.log("imagesThumbnailBySequences",arrTemp);
            } else {
                this.setState({
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    selectedSequence: {},
                    searchOpen: false,
                    searchOptionsOpen: true,
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
                console.log("Network error accessing data")
            }
        }

        fetchImagesThumbnailBySequencesInSession = async (session) => {
            let arrTemp = [];

            //const result = await this.apiCall("get", imagesThumbnailInSession + session.id, {}, );
            const result = await this.apiCall("get", sequencesBySession + session.id + "/deep", {},);
            //console.log("result", result.data);

            if (result) {
                arrTemp = result.data;

                let arrSession = [];
                if (arrTemp.length > 0) arrSession = arrTemp[0].images.map((image) => image);

                if (arrSession.length > 0) {
                    //console.log(arrTemp);
                    try {
                        let thumbnailsInSession = this.collectedThumbnailsInSession(arrTemp);
                        //console.log("colectedThumbnailsInSession", thumbnailsInSession);
                        if (arrSession.length > 0) {
                            //let urlImageFullsizeDefault = process.env.REACT_APP_API_BASE + imagesFullSizePng + arrTemp[0].id;
                            let urlImageFullsizeDefault = arrSession[0].id;
                            /*
                            //console.log(process.env.REACT_APP_API_BASE + imagesFullSizePng + arrTemp[0].id);
                            //console.log(session.sequences.length === 1 ? session.sequences[0] : {});
                        
                            console.log(arrSession[0]);
                            console.log(arrSession[0].id);*/

                            let thumbnailsData = this.calculateThumbnailsTemperatureValue(thumbnailsInSession);
                            //console.log(thumbnailsData);

                            const resultImage = await this.fetchImagesFullsize(arrSession[0].id);
                            /*console.log(arrSession[0].id);
                            console.log(resultImage);
                            console.log(session);
                            console.log(session.sequences.length);
                            console.log(arrSession);
                            console.log(thumbnailsData); */



                            this.setState({
                                selectedSession: session,
                                selectedSequence: session.sequences.length === 1 ? session.sequences[0] : {},
                                imagesThumbnailBySequences: thumbnailsInSession,
                                thumbnailsData: thumbnailsData,
                                selectedImagesThumbnail: urlImageFullsizeDefault,
                                selectedImagesThumbnailData: resultImage,
                                isExtendedImg: false,
                                alertMessage: ""
                            });
                        }
                    } catch (e) {
                        console.log("Error setting Thumbnails: ", e);
                    }
                } else {
                    this.setState({
                        loading: false,
                        selectedSession: session,
                        selectedSequence: {},
                        imagesThumbnailBySequences: [],
                        thumbnailsData: [],
                        selectedImagesThumbnail: "",
                        selectedImagesThumbnailData: [],
                        isExtendedImg: false,
                        alertSeverity: "error",
                        alertMessage: "Network error accessing data"

                    });
                }
            
            } else {
                this.setState({
                    loading: false,
                    selectedSession: session,
                    selectedSequence: {},
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    isExtendedImg: false,
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"

                });
            }
            
            
 
            //console.log(arrTemp);
        }

        collectedThumbnailsInSession =  (session) => {
            let arrImage = [];
            session.map((sequence) => { 
                sequence.images.map(image => arrImage.push(image)) });
            return arrImage;

        }

        fetchImagesFullsize = async (id) => {
            const result = await this.apiCall("get", imagesFullSize + id, {}, );
            if (result) {
                this.setState({
                    imageSize: [{ "x": result.data[0].width, "y": result.data[0].height }]
                });

                return result.data;
            } else {
                this.setState({
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    selectedSequence: {},
                    searchOpen: false,
                    searchOptionsOpen: true,
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
            }
        }      

    fetchImagesFullsizePng = async (imageI) => {

        // let urlImageFullsizeDefault = process.env.REACT_APP_API_BASE + imagesFullSizePng + imageI.id ;
        //console.log(imageI);
        let urlImageFullsizeDefault = imageI.id;
        const resultImage = await this.fetchImagesFullsize(imageI.id);
        //console.log(resultImage);
        if (this.state.colorMapSelected !== resultImage[0].colormap) this.fetchColorMap(resultImage[0].colormap);
        let isExtended = false;
        let isOpenList = true;

        // condition height - no  needed|| resultImage[0].height > 768 * 1.5
        //console.log(resultImage[0].width);
        //console.log(resultImage);
        if (resultImage[0].width > 1024 * 1.1) {
            isExtended = true;
            isOpenList = false;
        }
        this.setState({
            selectedImagesThumbnail: urlImageFullsizeDefault,
            selectedImagesThumbnailData: resultImage,
            imageSize: [{ "x": resultImage[0].width, "y": resultImage[0].height }],
            isExtendedImg: isExtended,
            openList: isOpenList
        });
    }  

        handleIsExtendedImg = (isExtendedImg) => {
            this.setState({ IsExtendedImg: isExtendedImg });
        }
    
         /**
         * Handle open patient list
         * @param {any} openList
         */
        handleOpenList = () => {
            this.setState({ openList: !this.state.openList });
        }

        fetchParameters = async () => {
        //const result = await this.apiCall("get", "/parameters", {});
        //this.setState({ parameters: result.data });
        }

    fetchColorMaps = async () => {
        const result = await this.apiCall("get", "/colormaps", {});
        if (result) {
            if (result.data.length > 0) { 
                this.setState({ colorMapList: result.data });
            }
        } else {
            this.setState({
                alertSeverity: "error",
                alertMessage: "Network error accessing data"
            });
        }
    }

        fetchColorMap = async (colorMapSelected) => {
            const result = await this.apiCall("get", corlormapUrl + colorMapSelected + "/scale/", {});
            if (result) {
                const image64 = this.getColorMapImage(colorMapSelected);
                this.setState({ colorMap: result.data, colorMapSelected: colorMapSelected, colorMapSelectedCode64: image64 });   // colorMapSelectedCode64: image64
                //console.log(this.state.colorMapSelectedCode64);
            } else {
                this.setState({
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    selectedSequence: {},
                    searchOpen: false,
                    searchOptionsOpen: true,
                    colorMap: [], 
                    colorMapSelected: "", 
                    colorMapSelectedCode64: "",
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
            }
        }

        // get image of ColorMap selected
        getColorMapImage = async (colorName) => {
            try {
                let isMounted = true;
                const imageData = await this.fetchImage(corlormapUrl + colorName + "/png/")
                    .then(data => {
                        if (isMounted) this.setState({ colorMapSelectedCode64: data.toString() });
                    });
                return () => { isMounted = false };
            } catch (err) {
                console.log(err);
            }
        }


        fetchImage = async (imageUrl) => {

            const result = await this.apiCallGetArrayBuffer("get", imageUrl, {});

            console.log(result.status);

            if (result) {

                //console.log(result.data);

                let data = new Uint8Array(result.data);
                //console.log(data);

                let raw = String.fromCharCode.apply(null, data);
                //console.log(raw);

                let base64 = btoa(raw);
                let src = "data:image;base64," + base64;

                //console.log("imageTemp", src);
                return src;
            } else {
                this.setState({
                    imagesThumbnailBySequences: [],
                    thumbnailsData: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    selectedSequence: {},
                    searchOpen: false,
                    searchOptionsOpen: true,
                    alertSeverity: "error",
                    alertMessage: "Network error accessing data"
                });
            }
        }

        handleAnimalSelect = async (animal, pos) => {
            this.clearOptions(animal,pos);
        }

        handleDataAnimalSelectByName = async (animalName, pos) => {
            this.clearOptionsSelectedName(animalName, pos);
        }

        handleOwnerSelectByName = async (ownerName, pos) => {
            this.clearOptionsSelectedOwnerName(ownerName, pos);
        }

        handleSequenceSelect = async (sequence) => { 
            this.fetchImagesThumbnailBySequences(sequence); 
            this.setAndSaveState({ selectedSequence: sequence, searchOpen: true, searchOptionsOpen: true,  }); 
        }

        handleColorMapSelected = async (colorMap) => {
            if (colorMap) this.fetchColorMap(colorMap.name); 
        }


        handleAnimalSelectByName = async (animalName) => {
            //console.log(animalName);
            if (!animalName.startsWith("(") && !animalName.endsWith(")"))  {
                //console.log(animalName);
                this.state.animalGralList.map((animal, pos) =>
                    animal.name === animalName ? this.handleDataAnimalSelectByName(animalName, pos) : null);
            } else {
                this.clearViewerData(animalName);
                this.fetchAnimalsHistory();
            }
        }

        handleLanguageSelected = async (lng) => {
            let animalsNameList = await this.handleAnimalsNameList(this.state.animalGralList);
            console.log(animalsNameList);
            let ownersNameList = await this.handleOwnersNameList(this.state.animalGralList);
            console.log(ownersNameList);
            if ((this.state.selectedAnimalName.startsWith("(") && this.state.selectedAnimalName.endsWith(")")) &&
                (this.state.selectedOwnerName.startsWith("(") && this.state.selectedOwnerName.endsWith(")"))) {

                this.setState({ languageSelected: lng, animalNameList: animalsNameList, selectedAnimalName: animalsNameList[0], ownersNameList: ownersNameList, selectedOwnerName: ownersNameList[0] });

            } else if ((this.state.selectedAnimalName.startsWith("(") && this.state.selectedAnimalName.endsWith(")")) &&
                (!this.state.selectedOwnerName.startsWith("(") && !this.state.selectedOwnerName.endsWith(")"))) {
                
                this.setState({ languageSelected: lng, animalNameList: animalsNameList, ownersNameList: ownersNameList, selectedAnimalName: animalsNameList[0] });

            } else if ((!this.state.selectedAnimalName.startsWith("(") && !this.state.selectedAnimalName.endsWith(")")) &&
                (this.state.selectedOwnerName.startsWith("(") && this.state.selectedOwnerName.endsWith(")"))) {
                
                this.setState({ languageSelected: lng, animalNameList: animalsNameList, ownersNameList: ownersNameList, selectedOwnerName: ownersNameList[0] });

            } else {
                this.setState({ languageSelected: lng, animalNameList: animalsNameList, ownersNameList: ownersNameList });
            }
        }


        clearViewerData = async (animalName) => {
            //console.log("ClearData");
            this.setState({

                selectedAnimal: {},
                fetchedAnimal: {},
                selectedAnimalName: "",
                animals: this.state.animalGralList,
                sessions: {},
                selectedSession: {},
                selectedSequence: {},
                imagesThumbnailBySequences: [],
                selectedImagesThumbnail: "",
                selectedImagesThumbnailData: [],
                animalInfoOpen: [false],
                sessionInfoOpen: [false],
                alertSeverity: ""
            });
        }



        calculateThumbnailsTemperatureValue = (thumbnails) => {
            let thumbnailsArr = [];
            if (thumbnails.length > 0) {

                //const { colorMap } = this.props;

                //console.log(thumbnails);

                thumbnails.forEach(async (thumbnail, i) => {
                    try {
                        if (thumbnail.secondaryimagedata) {
                            let imBuffer = loadImagerParameter(thumbnail.secondaryimagedata);
                            let sizey = 60;
                            let sizex = imBuffer.length / sizey;

                            let imagePixels = new jimp(sizex, sizey);

                            let image = createImageFromTempArray(imBuffer, imagePixels, sizex, sizey, this.state.colorMap,
                                thumbnail.mintemperaturescale,
                                thumbnail.maxtemperaturescale);

                            image.getBase64Async("image/png")
                                .then((response) => {
                                    thumbnailsArr[i] = response;
                                });
                            //console.log(image);
                        }
                    } catch (err) {
                        console.log(err);
                    }

                });
                //this.setState({ thumbnailsData: thumbnailsArr });
            }
            return thumbnailsArr;
        }


        
        login = async (username, password) => {
            const data = await apiLogin(username, password);
 
                const { user, accesstoken, accesstoken_expiry, refreshtoken, refreshtoken_expiry  } = data; 

                this.setState({ accesstoken, user, accesstoken_expiry, refreshtoken, refreshtoken_expiry });
                localStorage.setItem(AUTH_KEY, JSON.stringify({ accesstoken, user, accesstoken_expiry, refreshtoken, refreshtoken_expiry }));
                
                this.checkIfExpired();
            
            //this.checkUiVersion(true);
            //this.watchNewUiVersion();
        }

    checkIfExpired =  () => {
        this.clearTimers();
        this.timer_id = setInterval(() => {
            try {
                if (this.state.accesstoken_expiry && (new Date(this.state.accesstoken_expiry)).getTime() < new Date().getTime()) {
                    console.log(new Date().getTime())
                    if ((new Date(this.state.refreshtoken_expiry)).getTime() > new Date().getTime()) {
                        try {
                            //const refreshToken1 = this.apiCall("post", refreshTokenUrl, { "refreshtoken": this.state.refreshtoken })
                            const refreshToken1 = this.apiCallRefreshToken("post", refreshTokenUrl, { "refreshtoken": this.state.refreshtoken })
                                .then(
                                    (dataRes) => {
                                        if (dataRes)
                                            if (dataRes.status !== 401 || !dataRes.status) {
                                                try {
                                                    console.log(dataRes);
                                                    const { accesstoken, accesstoken_expiry, refreshtoken, refreshtoken_expiry } = dataRes.data;
                                                    console.log(accesstoken, accesstoken_expiry, refreshtoken, refreshtoken_expiry);
                                                    this.setState({ accesstoken, accesstoken_expiry, refreshtoken, refreshtoken_expiry });
                                                    localStorage.setItem(AUTH_KEY, JSON.stringify({
                                                        accesstoken, accesstoken_expiry, refreshtoken, refreshtoken_expiry,
                                                        user: this.state.user, newtoken: new Date()
                                                    }));
                                                    return dataRes;
                                                    //return Promise.resolve(true);
                                                } catch (e) {
                                                    console.log(e);
                                                    this.logout();
                                                }
                                            }
                                            else {
                                                this.logout();
                                            }
                                        else {
                                            this.logout();
                                        }


                                    });
                            //console.log(refreshToken1);
                        } catch (e) {
                            this.logout();
                        }
                    } else {
                        this.logout();
                    }
                } 
            } catch (e) {
                console.log("Error:", e);
            }

        }, 5 * 1000);   // Valid token 1 min = 60 * 1000
    }

      watchNewUiVersion() {
        this.setState({ alertMessage: "" });
        this.ui_check_timer_id = setInterval(() => {
          this.checkUiVersion(false);
        }, 60 * 1000);
      }


      clearTimers = () => {
        this.timer_id && clearInterval(this.timer_id);
        this.ui_check_timer_id && clearInterval(this.ui_check_timer_id);
      }

      logout = async () => {
        
        localStorage.removeItem(AUTH_KEY);
        this.clearTimers();
        this.clearData();
        await this.apiCall('get', logoutUrl)
        
      }
      clearData = () => {
          this.setState({ accesstoken: "", users: [], parameters: [], selectedUser: "", selectedParameter: "",
              
              accesstoken: "",
              accesstoken_expiry: {},
              refreshtoken: "",
              refreshtoken_expiry: {},

              alertSeverity: "",
              alertMessage: "",

              parameters: [],
              selectedParameter: {},

              localStorageChecked: false,
              languageSelected: "",
              searchOpen: false,

              searchOptionsOpen: true,

              availableOpc: true,

              animals: [],
              animalGralList: [],
              animalList: [],
              animalNameList: [],
              selectedAnimal: {},
              selectedAnimalName: "",

              animalInfoOpen: [],
              sessionInfoOpen: [],
              SequencenInfoOpen: [],

              owners: [],
              ownersNameList: [],
              selectedOwner: {},
              selectedOwnerName: "",

              sessions: [],
              selectedSession: {},

              sequences: [],
              selectedSequence: {},

              imagesThumbnailBySequences: [],
              selectedImagesThumbnail: "",
              selectedImagesThumbnailData: [],
              isExtendedImg: false,

              colorMapList: [],
              colorMap: [],
              colorMapSelected: "RainHi",   

              imageSize: [{ "x": 0, "y": 0 }],
              pixelTemp: 0.0,
              thumbnailsData: [],
              isFirstSearching: true,
              isCelcius: true,
          });
      }
      
    clearOptions = (item, pos) => {
        this.fetchAnimalOptions(item, pos);
    }

    clearOptionsSelectedName = (name, pos) => {
        this.fetchAnimalOptionsSelectedName(name, pos);
    }


    clearOptionsSelectedOwnerName = (name, pos) => {
        this.fetchAnimalOptionsSelectedOwnerName(name, pos);
    }

    fetchAnimalOptions =  (animal,i) => {

        //this.setState({ animals: [animal] });
        let arrInfoOpenTemp = this.state.animalInfoOpen;

        // TODO: set animalInfoOpen & sessionInfoOpen
        if (animal.sessions.length === 1) {                  
            arrInfoOpenTemp.fill(false);
            arrInfoOpenTemp[i] = true;
        }
              
        this.setState({
            animals: [animal],
            selectedAnimal: animal,
            selectedAnimalName: animal.name,
            selectedOwner: {},
            selectedOwnerName: "",
            sessions: animal.sessions,
            selectedSession: animal.sessions.length === 1 ? animal.sessions[0] : {},
            selectedSequence: animal.sessions.length > 0 ? animal.sessions[0].sequences.length === 1 ? animal.sessions[0].sequences[0] : {} : {}, 
            imagesThumbnailBySequences: [],
            selectedImagesThumbnail: "",
            animalInfoOpen: arrInfoOpenTemp,
            searchOpen: true,
                    
        });
    }

    fetchAnimalOptionsSelectedName =  (name, i) => {            
        let fetchedAnimal = [];
        const { animals, animalGralList} = this.state;
        if (this.state.selectedAnimalName !== name || animals.length !== 1 ) {
            //console.log(i);
            if (i !== -1 ) {
                if (this.state.animals.length > 1) {                    // return only one patient  
                    //this.fetchAnimalHistory(this.state.animalGralList[i].id);                        
                    fetchedAnimal = animals[i];
                } else {                                               // search all, but set only one
                    
                    fetchedAnimal = animalGralList[i];
                        
                }
                this.setState({ animals: [animalGralList[i]], isExtendedImg: false });
            } else { 
                //this.fetchAnimalsHistory(user) ;
                    
                this.setState({animals: animalGralList, isExtendedImg: false});
                fetchedAnimal = this.state.animalGralList[0];
            } 
                
            this.setState({

                selectedAnimal: fetchedAnimal,
                selectedAnimalName: name,
                selectedOwner: {},
                selectedOwnerName: "",
                sessions: fetchedAnimal.sessions,
                selectedSession: fetchedAnimal.sessions.length === 1 ? fetchedAnimal.sessions[0] : {},
                selectedSequence: fetchedAnimal.sessions.length > 0 ? fetchedAnimal.sessions[0].sequences.length === 1 ? fetchedAnimal.sessions[0].sequences[0] : {} : {} ,
                imagesThumbnailBySequences: [],
                selectedImagesThumbnail: "",
                selectedImagesThumbnailData: [],
                animalInfoOpen: [true],
                sessionInfoOpen: [false]
            });
        }

    }
        
    fetchAnimalOptionsSelectedOwnerName = (name, i) => {    
        let fetchedAnimalArr = [];
        let fetchedAnimal = {};
        const { animalGralList,  } = this.state;

        if (this.state.selectedOwnerName !== name ) {

            if (!name.startsWith("(") && !name.endsWith(")")) {
                animalGralList.map((animal) =>
                    animal.owners.map((owner) => owner.name === name ? fetchedAnimalArr[fetchedAnimalArr.length] = animal : null)
                );
                //console.log(fetchedAnimalArr);
                fetchedAnimal = fetchedAnimalArr[0];
                this.setState({
                    animals: fetchedAnimalArr,
                    selectedAnimal: {},
                    selectedAnimalName: "",
                    selectedOwner: fetchedAnimal.owners.length === 1 ? fetchedAnimal.owners[0] : {},
                    selectedOwnerName: name,
                    sessions: fetchedAnimal.sessions,
                    selectedSession: fetchedAnimal.sessions.length === 1 ? fetchedAnimal.sessions[0] : {},
                    selectedSequence: fetchedAnimal.sessions.length > 0 ? fetchedAnimal.sessions[0].sequences.length === 1 ? fetchedAnimal.sessions[0].sequences[0] : {} : {},
                    imagesThumbnailBySequences: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    animalInfoOpen: [false],
                    sessionInfoOpen: [false],
                    isExtendedImg: false

                });

            } else {
                
                fetchedAnimalArr = animalGralList;
                fetchedAnimal = {};

                let animalNameList = [];
                let ownersNameList = [];
                animalNameList.push(this.props.t("(No animal selected)"));
                ownersNameList.push(this.props.t("(No owner selected)"));
                animalGralList.forEach((animal, i) => {
                    animalNameList[i + 1] = animal.name;
                    animal.owners.map((owner, i) => (
                        ownersNameList.indexOf(owner.name) === -1 ? ownersNameList[ownersNameList.length] = owner.name : null));

                });
                //console.log(aTemp);
                

                //this.fetchAnimalsHistory();
                
                
                this.setState({
                    animals: fetchedAnimalArr,
                    selectedAnimal: {},
                    selectedAnimalName: "",
                    selectedOwner: {},
                    selectedOwnerName: name,
                    sessions: {},
                    selectedSession: {},
                    selectedSequence:  {},
                    imagesThumbnailBySequences: [],
                    selectedImagesThumbnail: "",
                    selectedImagesThumbnailData: [],
                    animalInfoOpen: [false],
                    sessionInfoOpen: [false],
                    isExtendedImg: false,
                    animalNameList: animalNameList, 
                    ownersNameList: ownersNameList

                });     
            }
        } 
    }

    apiCall = (method, url, data, cancelCallback) => {
    const { accesstoken } = this.state;
    return aCall(method, url, data, accesstoken, cancelCallback);
    }

    apiCallRefreshToken = (method, url, data, cancelCallback) => {
        const { accesstoken } = this.state;
        return aCall(method, url, data, accesstoken, cancelCallback);
    }
    apiCallGetArrayBuffer = (method, url, data, cancelCallback) => {
        const { accesstoken } = this.state;
        return aCallGetArrayBuffer(method, url, data, accesstoken, cancelCallback);
    }

      forceUiReload = () => {
        window.location.reload(true);
      }
      checkUiVersion = async (dontAsk) => {
        //const { accesstoken } = this.state;
        // TODO: set back when activate accesstoken
        /*if (accesstoken && this.ui_check_timer_id) {
          clearInterval(this.ui_check_timer_id);
          const { data: new_ui_available }  = await aCall("post", "/new_ui_available", { version: build }, accesstoken);
          if (new_ui_available) {
            if (dontAsk) {
              this.forceUiReload();
            } else {
              this.setState({ alertMessage: "New version of UI is available. Do you want to reload it now?" });
            }
          }
        }

          */
      }
      async setAndSaveState(props) {
        await this.setState(props);
        this.setStateToLocalStorage();
      }
      render() {
        return (
          <React.Fragment>
                <UserContext.Provider value={{
                    accesstoken: this.state.accesstoken,
                    user: this.state.user,
                    login: this.login,
                    logout: this.logout,
                    apiCall: this.apiCall,

                    alertSeverity: this.state.alertSeverity,
                    alertMessage: this.state.alertMessage,
                    handleMessage: (message) => this.setAndSaveState({ alertMessage: message }),

                    watchNewUiVersion: () => this.watchNewUiVersion(),
                    forceUiReload: () => this.forceUiReload(),

                    parameters: this.state.parameters,
                    selectedParameter: this.state.selectedParameter,
                    localStorageChecked: this.state.localStorageChecked,


                    handleParameterSelect: (parameter) => this.setAndSaveState({ selectedParameter: parameter }),
                    //handleLanguageSelected: (lng) => { this.setState({ languageSelected: lng})},
                    searchOpen: this.state.searchOpen,
                    availableOpc: this.state.availableOpc === true,

                    animals: this.state.animals,
                    animalGralList: this.state.animalGralList,
                    animalList: this.state.animalList,
                    
                    animalNameList: this.state.animalNameList,
                    
                    selectedAnimalName: this.state.selectedAnimalName,
                 
                    selectedAnimal: this.state.selectedAnimal,

                    animalInfoOpen: this.state.animalInfoOpen,
                    sessionInfoOpen: this.state.sessionInfoOpen,
                    handleAnimals: (user) => this.fetchAnimalsHistory(user),
                    handleAnimalSelect: (animal, pos) => this.handleAnimalSelect(animal, pos),
                    handleAnimalSelectByName: (animalName) => this.handleAnimalSelectByName(animalName),
                    handleAnimalsNameList: (animalsGralList) => this.handleAnimalsNameList(animalsGralList),

                    owners: this.state.owners,
                    ownersNameList: this.state.ownersNameList, 
                    selectedOwner: this.state.selectedOwner,
                    selectedOwnerName: this.state.selectedOwnerName,
                    handleOwnerSelect: (owner) => this.setAndSaveState({ selectedOwner: owner, }),

                    handleOwnerSelectByName: (ownerName,pos) =>  this.handleOwnerSelectByName(ownerName,pos),

                    sessions: this.state.sessions,
                    selectedSession: this.state.selectedSession,
                    handleSessionSelect: (session) => trackPromise(this.fetchImagesThumbnailBySequencesInSession(session)),

                    sequences: this.state.sequences,
                    selectedSequence: this.state.selectedSequence,
                    searchOptionsOpen: this.state.searchOptionsOpen,
                    handleSequenceSelect: (sequence) => this.handleSequenceSelect(sequence), 

                    imagesThumbnailBySequences: this.state.imagesThumbnailBySequences,
                    thumbnailsData: this.state.thumbnailsData,
                    selectedImagesThumbnail: this.state.selectedImagesThumbnail,
                    selectedImagesThumbnailData: this.state.selectedImagesThumbnailData,
                    handleSelectedImage: (img) => trackPromise(this.fetchImagesFullsizePng(img)),
                    isExtendedImg: this.state.isExtendedImg,
                    handleIsExtendedImg: (isExtended) => this.handleIsExtendedImg(isExtended),
                    openList: this.state.openList,
                    handleOpenList: (openList) => this.handleOpenList(openList),
                    languageSelected: this.state.languageSelected,
                    handleLanguageSelected: (lng) => this.handleLanguageSelected(lng),
                    imageSize: this.state.imageSize,

                    handleSearchOpen: () => this.setAndSaveState({ searchOpen: true }),
                    handleSearchOptions: () => this.setAndSaveState({searchOptionsOpen:true }),

                    colorMapList: this.state.colorMapList,
                    colorMap: this.state.colorMap,
                    colorMapSelected: this.state.colorMapSelected,
                    colorMapSelectedCode64: this.state.colorMapSelectedCode64,
                    fetchColorMaps: () => this.fetchColorMaps(),
                    handleColorMapSelected: (colorMap) => this.handleColorMapSelected(colorMap), 
                    fetchImage: (imageUrl) => this.fetchImage(imageUrl), 
                    isFirstSearching: this.state.isFirstSearching,
                    isCelcius: this.state.isCelcius,
                    handleIsCelcius: (temp) => this.setAndSaveState({isCelcius: !temp }),
                
            }}>
              {this.props.children}
            </UserContext.Provider>
          </React.Fragment>
        );
      }
}

export default withTranslation()(UserStore);

UserStore.propTypes = {
  children: PropTypes.object.isRequired,
};
